import React from 'react';
import { Checkbox, Col, Form, FormInstance, QRCode, Row, Typography } from 'antd';
import CollapseCommon from 'components/common/Collapse/CollapseCommon';
import BarcodeCommon from 'components/common/Barcode/BarcodeCommon';
import ModalCommon from 'components/common/Modal/ModalCommon';
import HeaderContent from 'components/common/HeaderContent/HeaderContent';
import { formatDate } from 'utils';
const { Text } = Typography;
export interface ReturnConfirmPanelProps {
  form: FormInstance;
  handleCreatecode?: () => void;
  handleBarcode?: () => void;
  selectedSupplierId?: string | number | undefined;
}
const ReturnConfirmPanel: React.FC<ReturnConfirmPanelProps> = ({ form, handleBarcode }) => {
  const [open, setOpen] = React.useState(false);
  const header = (
    <HeaderContent
      size='sm'
      key='confirm-create-product'
      label={`QUÉT MÃ ĐỂ LIÊN HỆ ZALO`}
      contentHeader={'Vui lòng quét mã để liên hệ trực tiếp với nhà cung cấp'}
    />
  );
  return (
    <div className='flex flex-col gap-6'>
      <CollapseCommon
        title='THÔNG TIN CHI TIẾT ĐƠN HÀNG TRẢ'
        collapseKey='info'
        hideExpandIcon
        disableCollapse
        className='!my-0 supplier-payment min-h-[780px]'
      >
        <Form form={form} layout='vertical'>
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                label={<span className='text-[var(--textBlack56)] leading-5'>Mã trả hàng</span>}
                className='mb-0'
              >
                <Text className='font-medium text-black'>{form.getFieldValue('code')}</Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={<span className='text-[var(--textBlack56)] leading-5'>Nhà cung cấp</span>}
                required={false}
                className='mb-0'
              >
                <Text className='font-medium text-black'>{form.getFieldValue('supplierName')}</Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={<span className='text-[var(--textBlack56)] leading-5'>Barcode</span>} className='mb-0'>
                <BarcodeCommon
                  valueBarcode={form.getFieldValue('barcode')}
                  displayGenerate={false}
                  onGenerate={handleBarcode}
                  displayValue={false}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={<span className='text-[var(--textBlack56)] leading-5'>Liên hệ</span>} className='mb-0'>
                <Text className='font-bold text-[var(--primaryColor500)] '>
                  {form.getFieldValue('supplierPhoneNumber')}
                </Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={<span className='text-[var(--textBlack56)] leading-5'>Email</span>} className='mb-0'>
                <Text className='font-bold text-[var(--primaryColor500)] '>{form.getFieldValue('supplierEmail')}</Text>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={<span className='text-[var(--textBlack56)] leading-5'>Zalo QR</span>} className='mb-0 '>
                <div className='flex items-center gap-3'>
                  <QRCode
                    size={30}
                    className='p-1'
                    value={`https://zalo.me/${form.getFieldValue('supplierPhoneNumber') || ''}`}
                  />
                  <p
                    className='text-[var(--primaryColor500)] cursor-pointer'
                    onClick={() => {
                      setOpen(true);
                    }}
                  >
                    Nhấp vào để xem
                  </p>
                </div>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={<span className='text-[var(--textBlack56)] leading-5'>Mô tả đơn hàng</span>}
                required={false}
                className='mb-0 '
              >
                <Text className='font-medium text-black'>{form.getFieldValue('describeOrder') || '---'}</Text>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <CollapseCommon
          title='THÔNG TIN NGƯỜI TRẢ'
          collapseKey='info'
          hideExpandIcon
          disableCollapse
          className='!my-0 -mx-6 !mt-8 !border-none !shadow-none'
          size='sm'
        >
          <Form form={form} layout='vertical'>
            <Row gutter={[24, 24]}>
              <Col span={8}>
                <Form.Item
                  label={<span className='text-[var(--textBlack56)] leading-5'>Tên nhân viên</span>}
                  className='mb-0'
                >
                  <Text className='font-medium text-black'>{form.getFieldValue('userName')}</Text>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={<span className='text-[var(--textBlack56)] leading-5'>Số điện thoại</span>}
                  required={false}
                  className='mb-0'
                >
                  <Text className='font-medium text-black'>{form.getFieldValue('phoneNumber')}</Text>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={<span className='text-[var(--textBlack56)] leading-5'>Email</span>}
                  required={false}
                  className='mb-0'
                >
                  <Text className='font-medium text-black'>{form.getFieldValue('email')}</Text>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Checkbox checked onChange={() => {}}>
                  Thông báo đến nhân viên để họ biết (Zalo, số điện thoại, Email,...)
                </Checkbox>
              </Col>

              <Col span={8}>
                <Form.Item
                  label={<span className='text-[var(--textBlack56)] leading-5'>Thời gian trả hàng</span>}
                  className='mb-0'
                >
                  <Text className='font-medium text-black'>
                    {formatDate(new Date(form.getFieldValue('deliveryDate')))}
                  </Text>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label={<span className='text-[var(--textBlack56)] leading-5'>Ghi chú</span>}
                  required={false}
                  className='mb-0 '
                >
                  <Text className='font-medium text-black'>{form.getFieldValue('describeNote') || '---'}</Text>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </CollapseCommon>
      </CollapseCommon>
      <ModalCommon
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onConfirm={() => {}}
        confirmLabel={'Nhắn qua Zalo ngay'}
        header={header}
      >
        <div className='flex flex-col items-center justify-center gap-4 p-6'>
          <QRCode
            size={324}
            className='p-1'
            value={`https://zalo.me/${form.getFieldValue('supplierPhoneNumber') || ''}`}
          />
          <p className='font-bold text-lg'>{form.getFieldValue('supplierName')}</p>
        </div>
      </ModalCommon>
    </div>
  );
};

export default ReturnConfirmPanel;
